/** @jsx React.DOM */

var React = require('react');
var Toolbar = require('./toolbar');
var EntryForm = require('./entryform');
var LoginView = require('./loginview');

module.exports = React.createClass({displayName: 'exports',
	componentDidMount: function() {
		var rsz = function() {
			$('.atf').height( $(window).height() );
			$('.btf').css('top', $(window).height() );
		}
		$(window).resize(rsz);
		rsz();
		$('.bottom').hide(); $('.btf').hide();
		$(this.getDOMNode()).find('.btf').html($('.btf').eq(0).html());
	},
	
	render: function() {
		return (
			React.DOM.div({className: "landing"}, 
				React.DOM.div({className: "atf"}, 
					Toolbar(null), 
					React.DOM.div({className: "middle"}, 
						 React.DOM.div({className: "landing-main"}, 
		                    React.DOM.h1(null, "Academic Word Finder", React.DOM.span(null, "Find the high value words in your text.")), 
		                    React.DOM.a({href: "#new", className: "landing-btn btn-new"}, React.DOM.span(null), React.DOM.data(null, "START A NEW ENTRY")), 
		                    React.DOM.a({href: "#continue", className: "landing-btn btn-continue"}, React.DOM.span(null), React.DOM.data(null, "ACCESS A SAVED ENTRY"))
	                	), 
	                	EntryForm({key: this.props.clearKey, errors: this.props.errors, onSubmit: this.props.onEntrySubmit}), 
	                	LoginView({errors: this.props.errors, onSubmit: this.props.onLogin})


                	), 
             React.DOM.div({className: "bottom"}, 
                "Scroll to learn more", 
                React.DOM.div(null, "’")
            )	
                	
				), 
				React.DOM.div({className: "btf"})
			)
		);
	}
});


//////////////////
// WEBPACK FOOTER
// ./landingview.js
// module id = 94
// module chunks = 0